import { GetState } from '@store/store';

export const toBusinessServiceEndpoint = (getState: GetState) => {
  const {
    config: { endpoints }
  } = getState();

  return endpoints.businessService;
};
